module.exports = __webpack_public_path__ + "static/media/cloud-hail-mixed.89386145.svg";